<template>
  <div class="price-range">
    <div class="name">Prix</div>
    <div class="range">
      <div class="price-slider" ref="slider"></div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider'

export default {
  name: 'PriceRangeSelector',
  props: {
    start: Number,
    end: Number,
    min: Number,
    max: Number
  },
  mounted () {

    let params = (new URL(document.location)).searchParams
    let priceStart = (params.get('price-min')) ? params.get('price-min') : this.start
    let priceEnd = (params.get('price-max')) ? params.get('price-max') : this.end

    noUiSlider.create(this.$refs.slider, {
      start: [priceStart, priceEnd],
      connect: true,
      step: 1,
      tooltips: {
        to: function (value) {
          return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
        }
      },
      range: {
        min: this.min,
        max: this.max
      }
    })

    this.$refs.slider.noUiSlider.on('update', (values, handle) => {
      this.$emit('update', { min: parseFloat(values[0]), max: parseFloat(values[1]) })
    })

  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.price-range{
  padding: 0 20px 0 0;
  margin-bottom: 20px;

  .name {
    font-size: px2rem(14px);
    font-weight: $fontBold;
    height: 54px;
    line-height: 54px;
    position: relative;
    cursor: pointer;
    padding-right: 34px;
  }
}
</style>
